import { store } from '@src/state/store';
import { getCurrentGame } from '@src/state/selectors/selector_game';
import { pushEventQueue } from '@src/state/slices/slice_game';
import { setShowFullViewLoader } from '@src/state/slices/slice_app';

import { Game } from '@src/lib/types';

export default () => (data: any) => {
  if (!data || !data.gameId || !data.status) return;

  const game: Game | null = getCurrentGame(store.getState());
  if (game === null)
    throw new Error('[_creatingOnchainGame] game not found in root state');

  if (data.gameId === game.gameId) {
    switch (data.status) {
      case 'pending':
        store.dispatch(setShowFullViewLoader(true));
        break;
      case 'failed':
        store.dispatch(setShowFullViewLoader(false));
        store.dispatch(
          pushEventQueue({
            message: 'Failed to create game onChain.',
            showToast: true,
            sound: 'error',
          }),
        );
        break;
      case 'success':
        store.dispatch(setShowFullViewLoader(false));
        break;
    }
  }
};
